import React from 'react'
import styled, { css } from '@mui/styled-engine-sc'
import ReactPerfectScrollbar from 'react-perfect-scrollbar'
import { List, ListProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

import { SidebarItemsType } from '../../types/sidebar'
import SidebarNavSection from './SidebarNavSection'

import '../../vendor/perfect-scrollbar.css'
import useAuth from '../../hooks/useAuth'

const baseScrollbar = css`
  background-color: ${(props) => props.theme.sidebar.background};
  /*border-right: 1px solid rgba(0, 0, 0, 0.12);*/
  flex-grow: 1;
`

const Scrollbar = styled('div')`
  ${baseScrollbar}
`

const PerfectScrollbar = styled(ReactPerfectScrollbar)`
  ${baseScrollbar}
`

const Items = styled('div')`
  padding-top: ${(props) => props.theme.spacing(2.5)};
  padding-bottom: ${(props) => props.theme.spacing(2.5)};
`

interface SidebarNavProps extends ListProps {
  items: {
    title?: string
    pages: SidebarItemsType[]
  }[]
}

const SidebarNav: React.FC<SidebarNavProps> = ({ onClick, items }) => {
  const { currentUser } = useAuth()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('md'))
  const ScrollbarComponent = (matches ? PerfectScrollbar : Scrollbar) as React.ElementType

  return (
    <ScrollbarComponent>
      <List onClick={onClick} disablePadding>
        <Items>
          {items &&
            currentUser &&
            items.map((item, index) => (
              <SidebarNavSection
                component="div"
                key={`${item.title}-${index}`}
                pages={item.pages.filter((page) =>
                  page.roles.some((role) => role === currentUser?.role)
                )}
                title={item.title}
              />
            ))}
        </Items>
      </List>
    </ScrollbarComponent>
  )
}

export default SidebarNav
